var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLido(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 46,
    viewBox: "0 0 175 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_667_141)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2091 0L27.664 17.8226L16.2091 24.4538L4.75415 17.8226L16.2091 0ZM8.25825 16.9758L16.2091 4.61122L24.1599 16.9758L16.2091 21.5768L8.25825 16.9758Z",
    fill: "white",
    fillOpacity: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.1987 28.3712L2.90976 20.6791L2.55116 21.2402C-1.53696 27.6061 -0.625072 35.941 4.74378 41.2868C11.0655 47.5711 21.3216 47.5711 27.6536 41.2868C33.0327 35.941 33.9446 27.6061 29.8462 21.2402L29.4876 20.6791L16.1987 28.3712Z",
    fill: "white",
    fillOpacity: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.6271 35.1453H58.5144V10.8547H63.1251V30.8605H73.6271V35.1453Z",
    fill: "white",
    fillOpacity: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M96.8033 35.1453H92.1926V10.8547H96.8033V35.1453Z",
    fill: "white",
    fillOpacity: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.492 35.1453V10.8547H123.391C124.59 10.8547 125.563 10.8955 126.301 10.9874C128.207 11.2118 129.856 11.8851 131.229 12.9971C132.623 14.1091 133.678 15.5374 134.395 17.2819C135.123 19.0162 135.481 20.9239 135.481 23.0051C135.481 25.0863 135.123 26.994 134.395 28.7385C133.668 30.4728 132.613 31.8909 131.229 33.0029C129.846 34.1149 128.207 34.7882 126.301 35.0126C125.553 35.1045 124.58 35.1453 123.391 35.1453H115.492ZM123.391 30.8299C124.59 30.8299 125.471 30.7687 126.035 30.6565C127.049 30.4524 127.899 29.9729 128.576 29.218C129.262 28.4529 129.774 27.5347 130.102 26.4533C130.44 25.3617 130.615 24.2089 130.615 22.9949C130.615 21.7809 130.44 20.5771 130.092 19.4855C129.754 18.3939 129.242 17.4757 128.545 16.731C127.869 15.9863 127.029 15.517 126.035 15.3333C125.471 15.2211 124.59 15.1599 123.391 15.1599H120.174V30.8197H123.391V30.8299Z",
    fill: "white",
    fillOpacity: 0.72
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.176 35.6554C160.769 35.6554 158.678 35.1351 156.885 34.0844C155.103 33.0234 153.73 31.5441 152.766 29.6262C151.814 27.7184 151.342 25.5046 151.342 22.995C151.342 20.4853 151.814 18.2715 152.766 16.3638C153.73 14.4561 155.103 12.9768 156.885 11.926C158.668 10.865 160.769 10.3447 163.176 10.3447C165.584 10.3447 167.674 10.8752 169.467 11.926C171.25 12.9768 172.623 14.4561 173.566 16.3638C174.529 18.2715 175.01 20.4853 175.01 22.995C175.01 25.5046 174.529 27.7184 173.566 29.6262C172.613 31.5339 171.25 33.0234 169.467 34.0844C167.684 35.1351 165.584 35.6554 163.176 35.6554ZM163.309 31.3401C164.805 31.3401 166.055 30.9932 167.07 30.3097C168.084 29.6262 168.853 28.657 169.355 27.4124C169.867 26.1677 170.113 24.6987 170.113 23.0052C170.113 20.3935 169.519 18.3532 168.32 16.8841C167.121 15.415 165.359 14.6703 163.033 14.6703C161.537 14.6703 160.287 15.0172 159.273 15.7007C158.258 16.3842 157.49 17.3534 156.988 18.598C156.475 19.8426 156.23 21.3117 156.23 23.0052C156.23 25.6168 156.824 27.6572 158.023 29.1263C159.221 30.5953 160.984 31.3401 163.309 31.3401Z",
    fill: "white",
    fillOpacity: 0.72
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_667_141"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 175,
    height: 46,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLido);
export default __webpack_public_path__ + "static/media/lido.0e938c4344dc21304516fbaaf086d363.svg";
export { ForwardRef as ReactComponent };